import React, { useMemo } from 'react';
import { useCombobox } from 'downshift';
import classNames from 'classnames';
import { Icon } from 'js/components';
import { useStandardCollator } from 'js/utils/string';

const standardCohorts = ['Reps', 'Users'];

function getCohortsFilter(inputValue) {
  inputValue = inputValue.toLowerCase();

  return function cohortsFilter(cohort) {
    return !inputValue || cohort.toLowerCase().includes(inputValue);
  };
}

function Cohort({
  placeholder = '(Cohort)',
  list = [],
  includeStandardCohorts = true,
  onChange = () => {},
  value,
}) {
  const collator = useStandardCollator();
  const fullList = useMemo(
    () =>
      (includeStandardCohorts ? [...standardCohorts, ...list] : list).sort(
        (a, b) => collator.compare(a, b)
      ),
    [includeStandardCohorts, list, collator]
  );

  const [items, setItems] = React.useState(fullList);

  const {
    isOpen,
    getToggleButtonProps,
    getMenuProps,
    getInputProps,
    highlightedIndex,
    getItemProps,
    selectedItem,
  } = useCombobox({
    onInputValueChange({ inputValue }) {
      setItems(fullList.filter(getCohortsFilter(inputValue)));
      onChange(inputValue);
    },
    items,
    itemToString(item) {
      return item.length ? item : '';
    },
    inputValue: value ?? '',
  });

  return (
    <div className="combobox">
      <div className="input-group">
        <input
          placeholder={placeholder}
          className="form-control"
          {...getInputProps()}
        />
        <div className="input-group-append">
          <span
            aria-label="toggle menu"
            className=""
            type="button"
            {...getToggleButtonProps()}
          >
            {isOpen ? (
              <Icon icon={['far', 'chevron-up']} fixedWidth />
            ) : (
              <Icon icon={['far', 'chevron-down']} fixedWidth />
            )}
          </span>
        </div>
      </div>
      <ul
        {...getMenuProps()}
        className="combobox-items"
        style={!isOpen ? { display: 'none' } : {}}
      >
        {isOpen &&
          items.map((item, index) => (
            <li
              className={classNames({
                highlighted: highlightedIndex === index,
                selected: selectedItem === item,
                'combobox-item': true,
              })}
              key={`${item.value}${index}`}
              {...getItemProps({ item, index })}
            >
              <span>{item}</span>
            </li>
          ))}
      </ul>
    </div>
  );
}

export default Cohort;
